export const enum ResponseCode {
    AccountLocked       = '002',    
    PasswordExpired     = '003',
    ForcePasswordReset  = '005',
    UserExists          = '007'
}